<template>
  <div :class="conditionalClass">
    <div
      v-if="label !== ''"
      :class="labelClass"
    >
      <label
        :id="idPrefix"
      >
        {{ toText(label) }}
      </label>
    </div>
    <div class="form-row-content">
      <div
        :aria-labelledby="`${idPrefix}`"
        class="pvd-toggle-btn"
        role="group"
      >
        <input
          :id="`${idPrefix}ToggleYes`"
          v-model="mutableToggleValue"
          v-validate="parsedRules"
          :name="`${idPrefix}ToggleStacked`"
          :aria-invalid="errors.has(name) ? true: null"
          :class="{'input-error': errors.has(name)}"
          type="radio"
          value="Yes"
          @change="handleClick"
        >
        <label
          :for="`${idPrefix}ToggleYes`"
        >
          <pvd-icon
            icon="checkmark"
            class="icon__white"
          />
          {{ yesLabel }}
        </label>
        <input
          :id="`${idPrefix}ToggleNo`"
          v-model="mutableToggleValue"
          :name="`${idPrefix}ToggleStacked`"
          :class="{'input-error': errors.has(name)}"
          type="radio"
          value="No"
          @change="handleClick"
        >
        <label
          :for="`${idPrefix}ToggleNo`"
        >
          <pvd-icon
            icon="checkmark"
            class="icon__white"
          />
          {{ noLabel }}
        </label>
      </div>
    </div>
    <div
      v-show="showInternalErrorMessage && errors.has(name)"
      :class="'form-row-message p-small-top'"
    >
      <pvd-system-message
        :id="`${idPrefix}Error`"
        :message="message"
        :placement="'inline'"
        :type="'alert'"
      />
    </div>
    <div
      v-if="supplementalRowText !== ''"
      class="form-row-supplemental"
    >
      <p
        class="xsmall"
      >
        {{ supplementalRowText }}
      </p>
    </div>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import validationHelper from '../mixins/validationHelper';
import utility from '../mixins/utility';

export default {
  name: 'ToggleComponent',
  mixins: [
    dataHelper,
    measurement,
    validationHelper,
    utility,
  ],
  inject: ['$validator'],
  $_veeValidate: {
    value() {
      return this.mutableToggleValue;
    },
    name() {
      return this.name;
    },
  },
  props: {
    idPrefix: {
      type: String,
      default: '',
    },
    yesLabel: {
      type: String,
      default: '',
    },
    noLabel: {
      type: String,
      default: '',
    },
    toggleValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    supplementalRowText: {
      type: String,
      default: '',
    },
    conditionalClass: {
      type: String,
      default: 'pvd-form-row',
    },
    labelClass: {
      type: String,
      default: 'form-row-label',
    },
    trackEvents: {
      type: Boolean,
      default: false,
    },
    validationRules: {
      type: Object,
      default: () => {},
    },
    message: {
      type: String,
      default: '',
    },
    showInternalErrorMessage: {
      type: String,
      default: 'false',
    },
  },
  computed: {
    mutableToggleValue: {
      get() {
        return this.toggleValue;
      },
      set(newValue) {
        this.$emit('update:toggleValue', newValue);
      },
    },
    parsedRules() {
      let rules = {};
      if (this.validationRules) {
        rules = this.parseRules(this.validationRules);
      }
      return rules;
    },
    name() {
      return `${this.idPrefix}ToggleStacked`;
    },
  },
  methods: {
    handleClick(event) {
      if (event && this.trackEvents) {
        const name = `${this.idPrefix}-${event.target.value}`;
        this.track(name, 'interaction');
      }
    },
  },
};
</script>

<style scoped>
</style>
